import React, { useCallback } from "react";
import AgGrid from "../AgGrid";

import SettingService from "../../../services/Setting";
import useTraceEntryColumnDef from "../../../hooks/Inventory/useTraceEntryColumnDef";

const TraceEntryReportTable = ({ gridRef, onGridReady, rowData, isReport }) => {
  const getAllItemGroupLevel1 = useCallback(async () => {
    const data = await SettingService.getAllCategory();
    return data;
  }, []);

  const columnDefs = useTraceEntryColumnDef(isReport, getAllItemGroupLevel1);

  return (
    <AgGrid
      ref={gridRef}
      columnDefs={columnDefs}
      height={680}
      onGridReady={onGridReady}
      rowData={rowData}
    />
  );
};

export default TraceEntryReportTable;
